import axios from "axios";
import { getNodeServerUrl } from "@utils/getNodeUrl";

const OAAP_BASE = `${getNodeServerUrl()}/oaap`;

/**
 * Get in-app notifications for a user.
 * @param {string} userCode
 * @returns {Promise}
 */
export const getNotificationsApi = (userCode) =>
  axios.get(`${OAAP_BASE}/notifications`, { params: { userCode } });

/**
 * Mark a single notification as read.
 * @param {number} id
 * @param {string} userCode
 * @returns {Promise}
 */
export const markNotificationReadApi = (id, userCode) =>
  axios.put(`${OAAP_BASE}/notifications/${id}/read`, { userCode });

/**
 * Mark all notifications as read for a user.
 * @param {string} userCode
 * @returns {Promise}
 */
export const markAllNotificationsReadApi = (userCode) =>
  axios.put(`${OAAP_BASE}/notifications/read-all`, { userCode });
